@if (!isSearching) {
  <button class="search__button" aria-label="Search" (click)="navigateToSearchResults()" ftrTooltip message="Search">
    <svg ftrIcon="Search" iconColor="Grey50" [iconSize]="24" class="align-top"></svg>
  </button>
} @else {
  <ftr-search-bar [courtSystemId]="courtSystemId" [searchTerms]="searchContext()?.searchTerms ?? ''" />
}
